import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  templateUrl: './invalidrequest.component.html',
  imports: [TranslatePipe]
})
export class InvalidRequestComponent {}
